import React, { useState, useCallback } from "react";
import SingleFieldDialog from "../../../dialogs/SingleFieldDialog/SingleFieldDialog";
import { useTranslation } from "react-i18next";
import AddNewButton from "../../../common/AddNewButton/AddNewButton";
import { Box } from "@material-ui/core";
import useEmployeeGroups from "../../../../state/EmployeeGroups";
import { useMe } from "../../../../state/Administrators";
import DownloadExcelButton from "../../../table/DownloadExcelButton/DownloadExcelButton";
import useTableUtils from "../../../../utils/Table";
import TableDatepicker from "../../TableDatepicker/TableDatepicker";

export default function GroupsHeader() {
  const { t } = useTranslation();
  const { canEditGroups } = useMe();
  const { tableQueryParam } = useTableUtils("groups");
  const { createEmployeeGroup, employeeGroups, loading, exportToExcel } =
    useEmployeeGroups(undefined, undefined, tableQueryParam);
  const [open, setOpen] = useState<boolean>(false);

  const handleCloseDialog = useCallback(() => setOpen(false), []);

  const handleOpenDialog = useCallback(() => setOpen(true), []);

  const handleAddDialog = useCallback(
    (value: string) => {
      handleCloseDialog();
      createEmployeeGroup(value);
    },
    [createEmployeeGroup, handleCloseDialog]
  );

  return (
    <Box width="100%" display="flex" justifyContent="flex-end">
      <DownloadExcelButton
        listLength={employeeGroups?.count}
        loading={loading}
        exportToExcel={exportToExcel}
        marginRight="8px"
      />
      <TableDatepicker mr="20px" />
      <AddNewButton disabled={!canEditGroups} onClick={handleOpenDialog}>
        {t("buttons.add_employee_group")}
      </AddNewButton>
      <SingleFieldDialog
        onCancelClick={handleCloseDialog}
        onActionClick={handleAddDialog}
        id="add-employee-group-dialog"
        open={open}
        title={t("groups.create_employee_group")}
        actionLabel={t("groups.create_group")}
        placeholder={t("groups.group_name")}
        tooltip="tooltip.create_employee_group_name"
      />
    </Box>
  );
}
